import React from "react";
import { Route, Routes } from "react-router-dom";
import PromotionCodesList from "./list/PromotionCodesList";
import CreatePromitionCode from "./create/CreatePromotionCode";

const PromotionCodesModule = () => {
  return (
    <Routes>
      <Route index element={<PromotionCodesList />} />
      <Route path="create" element={<CreatePromitionCode />} />
    </Routes>
  );
};

export default PromotionCodesModule;
